// extracted by mini-css-extract-plugin
export var addButton = "_cw-4";
export var contentBlockImage = "_cw-i";
export var contentBlockWidgetPreview = "_cw-g";
export var fulfillmentCutoffWidgetPreview = "_cw-9";
export var imageBackdrop = "_cw-6";
export var imageIcon = "_cw-8";
export var lowProfileImageContainer = "_cw-b";
export var lowProfileImageIcon = "_cw-f";
export var lowProfileImageIconContainer = "_cw-e";
export var lowProfileImagePlaceholder = "_cw-d";
export var lowProfileProductImage = "_cw-c";
export var lowProfileProductUpsellWidgetPreview = "_cw-a";
export var productCard = "_cw-5";
export var productImage = "_cw-7";
export var productReviewsWidgetPreview = "_cw-h";
export var progressBar = "_cw-1";
export var progressBarFill = "_cw-2";
export var progressBarTrack = "_cw-3";
export var shippingOptionWidgetPreview = "_cw-j";
export var shippingUpsellProgressBar = "_cw-k";
export var thresholdUpsellWidgetPreview = "_cw-0";